import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Páginas
import IndexPage from '../pages/IndexPage/IndexPage';
import ProdutosPage from '../pages/ProdutosPage/ProdutosPage';
import ServicosPage from '../pages/ServicosPage/ServicosPage';
import QuemSomosPage from '../pages/QuemSomosPage/QuemSomosPage';
import GerenciamentoPage from '../pages/GerenciamentoPage/GerenciamentoPage';
import LoginPage from '../pages/LoginPage/LoginPage';
import NotFoundPage from '../pages/NotFoundPage/NotFoundPage';
import AgendamentoPage from '../pages/AgendamentoPage/AgendamentoPage';
import CadastroPage from '../pages/CadastroPage/CadastroPage';
import PerfilPage from '../pages/PerfilPage/PerfilPage';
import RecuperarSenhaPage from '../pages/RecuperarSenhaPage/RecuperarSenhaPage'
import RedefinirSenhaPage from '../pages/RedefinirSenhaPage/RedefinirSenhaPage';


// Rota protegida com perfil
const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token'); 
  const userRole = localStorage.getItem('role'); 

  if (!token) return <LoginPage />;
  if (allowedRoles && !allowedRoles.includes(userRole)) return <NotFoundPage />; 

  return children;
};

export default function AppRoutes() {
  return (
    <Router>
      <Routes>
        {/* Página pública */}
        <Route path="/" element={<IndexPage />} />
        <Route path="/QuemSomos" element={<QuemSomosPage />} />
        <Route path="/Produtos" element={<ProdutosPage />} />
        <Route path="/Servicos" element={<ServicosPage />} />
        <Route path="/Cadastros" element={<CadastroPage />} />
        <Route path="/RecuperarSenha" element={<RecuperarSenhaPage />} />
        <Route path="/RedefinirSenha" element={<RedefinirSenhaPage />} />
        
        {/* Login */}
        <Route path="/Login" element={
          <PrivateRoute allowedRoles={['ROLE_USER','ROLE_ADMIN']}>
            <LoginPage />
          </PrivateRoute>
        }/>


        {/* Páginas acessíveis ao cliente */}
        <Route path="/Agendamentos" element={
          <PrivateRoute allowedRoles={['ROLE_USER','ROLE_ADMIN']}>
            <AgendamentoPage />
          </PrivateRoute>
        }/>
        <Route path="/Cadastros" element={
          <PrivateRoute allowedRoles={['ROLE_USER','ROLE_ADMIN']}>
            <CadastroPage />
          </PrivateRoute>
        }/>
        <Route path="/Perfil" element={
          <PrivateRoute allowedRoles={['ROLE_USER','ROLE_ADMIN']}>
            <PerfilPage />
          </PrivateRoute>
        }/>


        {/* Páginas acessíveis apenas ao Administrador  */}
        <Route path="/Gerenciamento" element={
          <PrivateRoute allowedRoles={['ROLE_ADMIN']}>
            <GerenciamentoPage />
          </PrivateRoute>
        }/>      
          
        {/* Rota para páginas inexistentes */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}
